export const MAX_PAGE_LIMIT = 50; // real backend cap is 100 (sociolla-core qs-parser); kept conservative
export const DEFAULT_LIMIT_WEB = 10;
export const DEFAULT_LIMIT_NATIVE = 15;

// ─── List fetch cache policy ───────────────────────────────────────────────
// Single switch governing how every migrated list/count query treats the RTK
// Query cache. Flip LIST_FETCH_MODE (and optionally the TTL) here — all screens
// that pass LIST_REFETCH_ON_CHANGE pick it up.
//
//   'cache'          → serve cached data on revisit; only refetch when the cached
//                      entry is older than LIST_CACHE_TTL_SECONDS.
//                      (set the TTL to 0 to cache forever while mounted.)
//   'always-refresh' → refetch on every mount / arg change; ignore the cache.
//
// Note: this is the *staleness window* (RTK's refetchOnMountOrArgChange). It is
// independent of how long unused cache is retained after leaving a screen —
// that's keepUnusedDataFor on the API (default 60s), tune separately if needed.
export const LIST_FETCH_MODE = 'always-refresh'; // 'cache' | 'always-refresh'
export const LIST_CACHE_TTL_SECONDS = 10;

// Resolved value to hand to RTK Query's `refetchOnMountOrArgChange`.
export const LIST_REFETCH_ON_CHANGE =
  LIST_FETCH_MODE === 'always-refresh' ? true : LIST_CACHE_TTL_SECONDS || false;

// ─── Re-apply refresh ───────────────────────────────────────────────────────
// When true, re-submitting the SAME search/filter forces a fresh fetch (e.g. you
// search "status = approved" again to pick up rows approved since). Implemented by
// including the params' `refreshTick` (bumped on every `filterAdded` — i.e. every
// Apply/search) in the query arg, so the serialized arg changes even when the filter
// content is identical. Pagination within a result set does NOT bump it, so paging
// still uses the cache.
// false → identical params serve from cache (standard RTK dedup).
export const LIST_REFETCH_ON_REAPPLY = true;

// Wrap a list/count query arg so identical-param re-submits refetch when the toggle
// is on. Pass the screen's scoped params object as the 2nd arg.
export const withReapplyRefresh = (arg, params) =>
  LIST_REFETCH_ON_REAPPLY ? { ...arg, refreshTick: params?.refreshTick } : arg;
